export default "__VITE_ASSET__Cy6aVJDJ__"